import { mapGetters, mapActions } from 'vuex';
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import { getAction } from '@/store/modules/actions/getters';
import * as WorkflowNodeService from '@/utils/workflow-node-service';
import { canEditWorkflow, nodesData } from '@/store/modules/workflows/getters';
import { editWorkflow } from '@/store/modules/selectedWorkflow/getters';
import { removeTempBlock, moveStepLocationInTree } from '@/store/modules/treeBlocks/actions';
import { setIsRouteSelected } from '@/store/modules/workflowGraphs/actions';
import { isMoveNodeActive } from '@/store/modules/treeBlocks/getters';
import { isSelectingWorkflowRoute, nodesInSelectedRoute } from '@/store/modules/workflowGraphs/getters';
import { element } from '@/store/modules/selectedWorkflow/getters';
import { getPlacement } from '@/store/modules/placements/getters';

export default {
	computed: {
		...mapGetters([getAction.fullPath, canEditWorkflow.fullPath]),
		...mapGettersShorthand({ element, editWorkflow, nodesData }),
		...mapGettersShorthand({ isMoveNodeActive, isSelectingWorkflowRoute, nodesInSelectedRoute, getPlacement }),
		elementPlacement() {
			return this.hasElement ? this.getPlacement(this.element.placement) : null;
		},
		hasElement() {
			return !!this.element;
		},
		workflow() {
			return this.editWorkflow;
		},
		isAllowedToEdit() {
			return this[canEditWorkflow.fullPath](this.workflow.id) && !this.isSelectingWorkflowRoute;
		},
	},
	methods: {
		...mapActions(['selectedNode/setEditNodeClick']),
		...mapActionsShorthand({ removeTempBlock, moveStepLocationInTree, setIsRouteSelected }),
		async onClickBlock(block) {
			if (block !== 'element') {
				if (this.isSelectingWorkflowRoute) {
					const nodes = this.nodesInSelectedRoute.map((nodeId) => this.nodesData()[Number(nodeId)]);
					const isTestedMap = nodes.map(
						(node) => WorkflowNodeService.isTestedSuccessfully(node) || WorkflowNodeService.isTestedSkipped(node)
					);
					const isValidRoute = isTestedMap.reduce((res, current) => res && current, true);
					if (isValidRoute) {
						this.setIsRouteSelected(true);
					} else {
						this.$toast.error('You cannot convert untested steps into a subflow. Test steps and try again.', { color: '#F79836' });
					}
				} else {
					return this['selectedNode/setEditNodeClick'](block);
				}
			}
		},
		isConsolidateDataNode(block) {
			return WorkflowNodeService.isConsolidateDataNode(block, this[getAction.fullPath]);
		},
		isBranches(node) {
			return WorkflowNodeService.isBranches(node);
		},
		isLoop(node) {
			return WorkflowNodeService.isLoop(node);
		},
		hasBlockAction(block) {
			return !!this[getAction.fullPath](block.action);
		},
		isBranchesRootBlock(block) {
			return this.isBranches(block) && !this.isConsolidateDataNode(block);
		},
		isWebhook(node) {
			return WorkflowNodeService.isWebhook(node);
		},
		isContextualNode(block) {
			return this.element?.action_context_node === block.id;
		},
	},
	data() {
		return {};
	},
};
